import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const PastMedicalProceduresHistoryPage = lazy(
  () => import("./PastMedicalProceduresHistoryPage"),
);

const PastMedicalProceduresHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <PastMedicalProceduresHistoryPage />
    </Suspense>
  );
};

export default PastMedicalProceduresHistoryPageLazy;
